export const intervention = {
  name_one: "intervention",
  name_other: "interventions",
  add: {
    label: "Ajouter une intervention",
  },
  addTemplate: "Appliquer un gabarit",
  batchEdit: {
    formError: {
      default:
        "Une erreur est survenue lors de la mise à jour des interventions.",
      noItemUpdated: "Aucune intervention n'a été modifié.",
    },
    state: {
      optionTitle: "État des interventions",
      label: "État",
    },
    template: {
      optionTitle: "Gabarit des interventions",
      label: "Gabarit",
    },
    scheduledDate: {
      optionTitle: "Date planifiée des interventions",
      label: "Date planifiée",
    },
    users: {
      optionTitle: "Utilisateurs des interventions",
      label: "Utilisateurs",
    },
  },
  batchEditSelect: {
    selected_one: "intervention sélectionnée.",
    selected_other: "interventions sélectionnées.",
  },
  batchTransition: {
    description_one:
      "Veuillez appliquer un nouvel état à l'intervention sélectionnée.",
    description_other:
      "Veuillez appliquer un nouvel état aux différentes interventions sélectionnées.",
    info: "Les interventions écartées ne peuvent pas être modifiées.",
    formSuccess:
      "Toutes les intervention '{{initialState}}' ont été modifiées à l'état '{{newState}}'.",
    formErrorGeneric:
      "Une erreur est survenue lors de la modification des interventions '{{initialState}}'.",
    formErrorItems:
      "Les interventions suivantes n'ont pas pu être modifiées: {{items}}.",
  },
  delete: {
    label: "Supprimer l'intervention",
  },
  details: {
    label: "Détails",
  },
  dissociate: {
    title: "Dissocier l'intervention",
    question: {
      project:
        "Dissocier l'intervention « {{intervention}} » du projet « {{project}} » ?",
    },
  },
  batchDissociate: {
    title: "Dissocier les interventions",
    question: {
      project:
        "Dissocier les interventions sélectionnées du projet « {{project}} » ?",
    },
  },
  followUp: {
    button: {
      disabled:
        "L’intervention doit être complétée et aucun suivi n'existe pour pouvoir faire le suivi.",
    },
    checkbox: {
      label: "Faire le suivi des observations complétées.",
    },
    info: {
      pictures:
        "Les photos ne seront pas dupliquées mais resteront consultables dans l’intervention d’origine.",
      recommendations:
        "Les recommandations des observations ne seront pas dupliquées mais liées à la nouvelle intervention.",
    },
  },
  duplicate: {
    checkbox: {
      label: "Dupliquer le contenu de l'intervention",
      info: "L'intervention ne sera associée à aucun projet. Les interventions recommandées seront liées et non dupliquées.",
    },
  },
  form: {
    add: {
      label: "Ajouter une intervention",
    },
    creationDate: {
      label: "Date de création",
      tooltip:
        "Date de création de l’intervention permettant de déduire le délai maximum d’intervention et la date de la prochaine étude",
    },
    associateInterventionWith: "Associer cette intervention avec",
    informations: "Informations de l'intervention",
    scheduledDate: {
      label: "Date planifiée",
    },
    description: {
      label: "Description",
    },
    edit: {
      label: "Modifier l'intervention",
    },
    name: {
      label: "Nom",
    },
    provider: {
      label: "Fournisseur",
    },
    users: {
      label: "Utilisateurs",
    },
    template: {
      label: "Gabarit",
    },
    state: {
      label: "État",
    },
    cost: {
      label: "Coût",
      error: "Le coût devrait être supérieur à 0$",
    },
    costType: {
      label: "Type de coût",
      capex: "CAPEX",
      opex: "OPEX",
    },
    maxDaysDelay: {
      label: "Délai maximum en jours",
      error: "1 jour minimum",
    },
    subtype: {
      label: "Sous-type d'intervention",
    },
    type: {
      label: "Type d'intervention",
    },
    progress: {
      label: "Progression",
    },
    templateSelectGroup: {
      local: "Gabarits de l'actif",
      global: "Autres gabarits",
    },
    noTemplate: "Aucun gabarit",
  },
  recommendedBy: {
    label: "Recommandée par",
  },
  launch: "Lancer",
  map: "Carte",
  modules: {
    label: "Rapports et Modules",
  },
  noTemplate: "Intervention sans gabarit",
  observations: { label: "Observations" },
  plan: "Plan",
  recommendedInterventions: {
    label: "Interventions recommandées",
    labelWithCount: "Interventions recommandées ({{count}})",
  },
  running: "En exécution",
  seeChildrenInterventions: {
    label: "Voir les interventions enfants",
  },
  seeParentIntervention: {
    label: "Voir l'intervention parent",
  },
  validation: {
    valid: "Validé par",
    needsValidation: "Requiert une validation",
    hasChanges: "Sauvegarder les changement avant de valider",
  },
  menu: {
    title: "Table des matières",
    loopOnChildrenTooltip: "Boucle sur les enfants : {{sectionName}}",
    assetTypeTooltip: "Type d'actif : {{assetType}}",
  },
  sectionEmpty: {
    description: {
      form: "Aucun formulaire disponible.",
      tabs: "Aucune information complémentaire disponible.",
    },
    additionalInfoTitle: "Informations complémentaires",
    checkTemplate: "Vérifier le gabarit utilisé.",
  },
};
